module.exports = __webpack_public_path__ + "static/img/location.c74bb79f.svg";